import { Model } from "vuex-fetch-factory";

export interface AccessLogEntryRaw {
  relation_id: number;
  invoice_id: number;
  created_at: Date;
}

export class AccessLogEntryModel
  implements Model<AccessLogEntryModel, AccessLogEntryRaw>
{
  public relation_id = 0;
  public invoice_id = 0;
  public created_at = new Date();

  public getNew(): AccessLogEntryModel {
    return new AccessLogEntryModel();
  }

  public fillModel(raw: AccessLogEntryRaw): this {
    this.relation_id = raw.relation_id;
    this.invoice_id = raw.invoice_id;
    this.created_at = raw.created_at;
    return this;
  }

  public getRaw(): AccessLogEntryRaw {
    return {
      relation_id: this.relation_id,
      invoice_id: this.invoice_id,
      created_at: this.created_at,
    };
  }
}
